import { useState } from 'react';
import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              专题推荐
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              精选影视专题合集，发现更多精彩内容
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {carouselItems.map((item, idx) => (
              <CarouselCard key={idx} item={item} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function CarouselCard({ item }: { item: (typeof carouselItems)[number] }) {
  const [imgError, setImgError] = useState(false);

  return (
    <div className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/60 cursor-pointer transition-all duration-300 hover:-translate-y-1">
      <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
        {!imgError ? (
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-background-200">
            <i className="ri-image-line text-4xl text-foreground-300"></i>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-base font-heading font-bold text-background-50 mb-1">{item.title}</h3>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
      </div>
    </div>
  );
}